import { animateValue } from "./utils/animations"
import { onUserViewPort } from "./utils/isOnPageView"
import { handleHeaderSripts } from "./utils/header"
import { handleLanguage } from "./utils/lang"

function animateNumbers () {
    const numberBlocks = document.querySelectorAll(".about-map__numbers .numbers-block")

    numberBlocks.forEach(el => {
        const number = el.querySelector(".numbers-block__number") as HTMLElement

        if (number) {
            const value = number.getAttribute("data-number")
            animateValue(number, 0, parseFloat(value), 1500)
        }
    })
}

window.addEventListener("load", () => {
    onUserViewPort(animateNumbers, document.querySelector(".about-map__numbers"))
    handleHeaderSripts()
    handleLanguage()
})